// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1ohvV","list":"styles_list__ULw5h"};